import React, { useEffect } from 'react'
import { Navigate } from 'react-router-dom'

function Logout (props) {
  // NOTE - wrap function in useEffect otherwise we get error
  // Cannot update a component (`App`) while rendering a different component
  useEffect(() => {
    props.handleLogout()
  }, [])

  return (
    <Navigate to="/login" replace />
  )
}

export default Logout
